// src/pages/MentalPlus/IslandRegistry.tsx
import { motion } from "framer-motion";
import type { ComponentType } from "react";

// ---- SVG Imports AS URLS ----
// (important for performance + re-use in D3 charts)

import HumeurNuitUrl from "../../assets/MentalPlus/MOI/sleep.png?url";
import HumeurSoleilUrl from "../../assets/MentalPlus/MOI/verygood.png?url";
import HumeurNuageUrl from "../../assets/MentalPlus/MOI/good.png?url";
import HumeurCouvertUrl from "../../assets/MentalPlus/MOI/neutral.png?url";
import HumeurPluieUrl from "../../assets/MentalPlus/MOI/sad.png?url";
import HumeurOrageUrl from "../../assets/MentalPlus/MOI/crying.png?url";

// ------- AMIS -------
import AmisNuitUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Nuit.svg?url";
import AmisSoleilUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Soleil.svg?url";
import AmisNuageUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Nuage.svg?url";
import AmisCouvertUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Couvert.svg?url";
import AmisPluieUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Pluie.svg?url";
import AmisOrageUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Orage.svg?url";

// ------- AMOUR -------
import AmourNuitUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Nuit.svg?url";
import AmourSoleilUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Soleil.svg?url";
import AmourNuageUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Nuage.svg?url";
import AmourCouvertUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Couvert.svg?url";
import AmourPluieUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Pluie.svg?url";
import AmourOrageUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Orage.svg?url";

// ------- ECRANS -------
import EcransNuitUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Nuit.svg?url";
import EcransSoleilUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Soleil.svg?url";
import EcransNuageUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Nuage.svg?url";
import EcransCouvertUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Couvert.svg?url";
import EcransPluieUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Pluie.svg?url";
import EcransOrageUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Orage.svg?url";

// ------- ETUDES (not yet used in registry but ready) -------
import EtudesNuitUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Nuit.svg?url";
import EtudesSoleilUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Soleil.svg?url";
import EtudesNuageUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Nuage.svg?url";
import EtudesCouvertUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Couvert.svg?url";
import EtudesPluieUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Pluie.svg?url";
import EtudesOrageUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Orage.svg?url";

// ------- FAMILLE -------
import FamilleNuitUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Nuit.svg?url";
import FamilleSoleilUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Soleil.svg?url";
import FamilleNuageUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Nuage.svg?url";
import FamilleCouvertUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Couvert.svg?url";
import FamillePluieUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Pluie.svg?url";
import FamilleOrageUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Orage.svg?url";

// ------- LOISIRS -------
import LoisirsNuitUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Nuit.svg?url";
import LoisirsSoleilUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Soleil.svg?url";
import LoisirsNuageUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Nuage.svg?url";
import LoisirsCouvertUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Couvert.svg?url";
import LoisirsPluieUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Pluie.svg?url";
import LoisirsOrageUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Orage.svg?url";

// ----------------------------------------------------
// Weather keys & scale types
// ----------------------------------------------------

export type WeatherKey =
  | "nuit"
  | "soleil"
  | "nuage"
  | "couvert"
  | "pluie"
  | "orage";

export type ScaleOutputMode = "emoji" | "sprite";

export interface ScaleDef {
  min: number;
  max: number;
  mode: ScaleOutputMode;
  /**
   * - if mode === "emoji": returns an emoji (e.g. "🙂")
   * - if mode === "sprite": returns a sprite key (e.g. "soleil", "orage", "low", "high"...)
   */
  map: (score: number) => string;
}

export interface SequenceVisualConfig {
  sequenceId?: number;
  chartType?: "circles" | "emojis" | "sprites";
  scale?: ScaleDef;
}

export interface IslandDef {
  key: string;
  title: string;

  // main questionnaire (non-inline)
  main: SequenceVisualConfig;

  // inline questionnaire
  inline?: SequenceVisualConfig;

  // which sequence’s scale is used to pick the icon sprite
  iconFromInline?: boolean;

  // base/night icon component (wrapped from url)
  Component: ComponentType<any>;
  dx?: number;
  dy?: number;
  subs?: IslandDef[];
  iconWidth?: number | string;

  // sprite set for this island – your “weather” svgs as React components
  weatherSprites?: Partial<Record<WeatherKey, ComponentType<any>>>;

  // raw URLs for those sprites, reused in EvolutionChart
  spriteUrls?: Partial<Record<WeatherKey, string>>;
}

// ----------------------------------------------------
// Helpers: wrap URL → motion.div + combined sprite sets
// ----------------------------------------------------

// Given a URL, return a motion.div that uses it as background-image
function wrapFromUrl(url: string): ComponentType<any> {
  const Wrapped: ComponentType<any> = (props: any) => (
    <motion.div
      {...props}
      style={{
        ...(props.style ?? {}),
        backgroundImage: `url("${url}")`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
  );
  return Wrapped;
}

// Takes a mapping (WeatherKey -> url) and returns both:
// - weatherSprites: WeatherKey -> wrapped component
// - spriteUrls: WeatherKey -> raw url (for D3 charts)
function makeSpriteSet(urls: Record<WeatherKey, string>) {
  const weatherSprites: Partial<Record<WeatherKey, ComponentType<any>>> = {};
  (Object.keys(urls) as WeatherKey[]).forEach((key) => {
    weatherSprites[key] = wrapFromUrl(urls[key]);
  });

  return {
    weatherSprites,
    spriteUrls: urls,
  };
}

// ----------------------------------------------------
// Sprite URL maps per island
// ----------------------------------------------------

const amisSpriteUrls: Record<WeatherKey, string> = {
  nuit: AmisNuitUrl,
  soleil: AmisSoleilUrl,
  nuage: AmisNuageUrl,
  couvert: AmisCouvertUrl,
  pluie: AmisPluieUrl,
  orage: AmisOrageUrl,
};

const familleSpriteUrls: Record<WeatherKey, string> = {
  nuit: FamilleNuitUrl,
  soleil: FamilleSoleilUrl,
  nuage: FamilleNuageUrl,
  couvert: FamilleCouvertUrl,
  pluie: FamillePluieUrl,
  orage: FamilleOrageUrl,
};

const amourSpriteUrls: Record<WeatherKey, string> = {
  nuit: AmourNuitUrl,
  soleil: AmourSoleilUrl,
  nuage: AmourNuageUrl,
  couvert: AmourCouvertUrl,
  pluie: AmourPluieUrl,
  orage: AmourOrageUrl,
};

const ecransSpriteUrls: Record<WeatherKey, string> = {
  nuit: EcransNuitUrl,
  soleil: EcransSoleilUrl,
  nuage: EcransNuageUrl,
  couvert: EcransCouvertUrl,
  pluie: EcransPluieUrl,
  orage: EcransOrageUrl,
};

const loisirsSpriteUrls: Record<WeatherKey, string> = {
  nuit: LoisirsNuitUrl,
  soleil: LoisirsSoleilUrl,
  nuage: LoisirsNuageUrl,
  couvert: LoisirsCouvertUrl,
  pluie: LoisirsPluieUrl,
  orage: LoisirsOrageUrl,
};

const humeurSpriteUrls: Record<WeatherKey, string> = {
  nuit: HumeurNuitUrl,
  soleil: HumeurSoleilUrl,
  nuage: HumeurCouvertUrl,
  couvert: HumeurNuageUrl,
  pluie: HumeurPluieUrl,
  orage: HumeurOrageUrl,
};

// (Etudes sprites ready if you later add that island)
const etudesSpriteUrls: Record<WeatherKey, string> = {
  nuit: EtudesNuitUrl,
  soleil: EtudesSoleilUrl,
  nuage: EtudesNuageUrl,
  couvert: EtudesCouvertUrl,
  pluie: EtudesPluieUrl,
  orage: EtudesOrageUrl,
};

// ----------------------------------------------------
// Shared scales
// ----------------------------------------------------

const likertSpriteScale: ScaleDef = {
  min: 0,
  max: 4,
  mode: "sprite",
  map: (score: number): WeatherKey => {
    if (score >= 3.8) return "soleil";
    if (score >= 3) return "couvert";
    if (score >= 2) return "nuage";
    if (score >= 1) return "pluie";
    return "orage";
  },
};
const likertEmojiScale: ScaleDef = {
  min: 0,
  max: 4,
  mode: "emoji",
  map: (score: number) => {
    if (score >= 3.8) return "☀️";
    if (score >= 3) return "⛅";
    if (score >= 2) return "☁️";
    if (score >= 1) return "🌧️";
    return "⛈️";
  },
};

// ----------------------------------------------------
// Island registry
// ----------------------------------------------------

export const ISLAND_REGISTRY: Record<string, IslandDef> = {
  amis: {
    key: "amis",
    title: "Amis",
    Component: wrapFromUrl(AmisNuitUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 10,
      chartType: "circles", // numeric circles
    },

    inline: {
      sequenceId: 11,
      chartType: "sprites",
      scale: likertSpriteScale, // sprite-based Likert
    },

    iconFromInline: true,
    ...makeSpriteSet(amisSpriteUrls),
  },

  famille: {
    key: "famille",
    title: "Famille",
    Component: wrapFromUrl(FamilleNuitUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 8,
      chartType: "circles",
    },

    inline: {
      sequenceId: 9,
      chartType: "sprites",
      scale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(familleSpriteUrls),
  },

  amour: {
    key: "amour",
    title: "Amour",
    Component: wrapFromUrl(AmourNuitUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 14,
      chartType: "circles",
    },

    inline: {
      sequenceId: 15,
      chartType: "sprites",
      scale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(amourSpriteUrls),
  },

  ecrans: {
    key: "ecrans",
    title: "Écrans",
    Component: wrapFromUrl(EcransNuitUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 6,
      chartType: "circles",
    },

    inline: {
      sequenceId: 7,
      chartType: "sprites",
      scale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(ecransSpriteUrls),
  },

  loisirs: {
    key: "loisirs",
    title: "Loisirs",
    Component: wrapFromUrl(LoisirsNuitUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 16,
      chartType: "circles",
    },

    inline: {
      sequenceId: 17,
      chartType: "emojis",
      scale: likertEmojiScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(loisirsSpriteUrls),
  },

  humeur: {
    key: "humeur",
    title: "Moi",
    Component: wrapFromUrl(HumeurNuitUrl),
    iconWidth: "140px",

    // main sequence uses emojis
    main: {
      sequenceId: 12,
      chartType: "emojis",
      scale: {
        min: 0,
        max: 15,
        mode: "emoji",
        map: (score: number) => {
          if (score >= 12) return "😄";
          if (score >= 9) return "🙂";
          if (score >= 6) return "😐";
          if (score >= 3) return "☹️";
          return "😢";
        },
      },
    },

    // inline sequence drives sprites (same Likert scale)
    inline: {
      sequenceId: 13,
      chartType: "sprites",
      scale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(humeurSpriteUrls),
  },
};

// ----------------------------------------------------
// Derived convenience structures
// ----------------------------------------------------

export const ISLANDS = {
  top: ["famille", "amis"].map((k) => ISLAND_REGISTRY[k]),
  bottom: ["amour", "ecrans", "loisirs"].map((k) => ISLAND_REGISTRY[k]),
  center: ISLAND_REGISTRY.humeur,
};

export const SUBISLANDS: Record<string, IslandDef[]> = Object.fromEntries(
  Object.entries(ISLAND_REGISTRY)
    .filter(([_, v]) => v.subs?.length)
    .map(([k, v]) => [k, v.subs!])
);

export const TITLE_MAP = Object.fromEntries(
  Object.entries(ISLAND_REGISTRY).flatMap(([k, v]) => [
    [k, v.title],
    ...(v.subs?.map((s) => [s.key, s.title]) ?? []),
  ])
);

export const SEQUENCE_MAP = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => {
    const pairs: [string, number][] = [];
    if (parent.main.sequenceId) {
      pairs.push([parent.key, parent.main.sequenceId]);
    }
    parent.subs?.forEach((s) => {
      if (s.main.sequenceId) {
        pairs.push([s.key, s.main.sequenceId]);
      }
    });
    return pairs;
  })
);

// inline sequences
export const INLINE_SEQUENCE_MAP = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => {
    const pairs: [string, number][] = [];
    if (parent.inline?.sequenceId) {
      pairs.push([parent.key, parent.inline.sequenceId]);
    }
    parent.subs?.forEach((s) => {
      if (s.inline?.sequenceId) {
        pairs.push([s.key, s.inline.sequenceId]);
      }
    });
    return pairs;
  })
);

// used by EvolutionChart / EvolutionCalendar
export interface SequenceRenderCfg {
  chartType: "circles" | "emojis" | "sprites";
  scale?: ScaleDef;
  spriteUrls?: Partial<Record<WeatherKey, string>>; // "soleil", "pluie", ...
}

export const SEQUENCE_RENDER_MAP: Record<number, SequenceRenderCfg> =
  Object.fromEntries(
    Object.values(ISLAND_REGISTRY)
      .flatMap((island) => [island, ...(island.subs ?? [])])
      .flatMap((island) => {
        const entries: { id: number; cfg: SequenceRenderCfg }[] = [];

        const addCfg = (seqCfg?: SequenceVisualConfig) => {
          if (!seqCfg?.sequenceId) return;
          entries.push({
            id: seqCfg.sequenceId,
            cfg: {
              chartType: seqCfg.chartType ?? "circles",
              scale: seqCfg.scale,
              // same island spriteUrls for both main & inline sequences
              spriteUrls: island.spriteUrls,
            },
          });
        };

        addCfg(island.main);
        addCfg(island.inline);

        return entries;
      })
      .map(({ id, cfg }) => [id, cfg] as const)
  );

// Flat map: key -> IslandDef for both islands and subislands
export const ALL_ISLANDS: Record<string, IslandDef> = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => [
    [parent.key, parent],
    ...(parent.subs?.map((s) => [s.key, s]) ?? []),
  ])
);
